import React, { useState } from "react";
import i18next from "i18next";
import { useConvertContext } from "../../Contexts/ConvertContext";
import { IMultiRowList } from "../Coordinates/DropdownList";
import { DropdownType } from "../enums";
import { AdvancedDropdown } from "../Coordinates/AdvancedDropdown";
import { coordinateFormat } from "../Coordinates/CoordinateUtils";
import "./CoordSystemSelect.scss";

const xArrow = "\u2192 ";
const yArrow = "\u2191 ";
const replacement = "x(N) " + yArrow + ", y(E) " + xArrow;
const replacement2 = "x(E) " + xArrow + ", y(N) " + yArrow;

export const CoordSystemSelect = (): JSX.Element => {
    const { coordinates, formatType, setFormatType, allCoordinates } = useConvertContext();

    const [formatName, setFormatName] = useState("LKS92");

    const changeFormat = (attribute?: IMultiRowList) => {
        if (!attribute) {
            return;
        }

        const formatNameNew = attribute.labelRows[0].toString().replace(replacement, "").replace(replacement2, "");
        setFormatType(attribute.value as coordinateFormat);
        setFormatName(formatNameNew);
    };

    return (
        <div className="convert-inputs unselectable">
            <AdvancedDropdown
                title={i18next.t("coordinates.typeTitle")}
                attributes={allCoordinates}
                text={formatName + " " + coordinates}
                alwaysOpen={false}
                hideTextOnOpen={true}
                buttonAsRow={true}
                closeOnSubmit={true}
                selectedValue={formatType}
                type={DropdownType.MultiLine}
                clicked={(at: IMultiRowList) => changeFormat(at)}
                chevronClass={["esri-icon-up", "esri-icon-down"]}
            />
        </div>
    );
};
